import { FC, createContext, useContext, useState, Dispatch, SetStateAction } from "react";
import {
    QueryState,
    initialQueryState,
    WithChildren,
    ID
} from "../../../../../../../../_metronic/helpers";
import { DLMApplication, DLMSiteApplication } from "../../../../_models";


type DLMLabelObject = { 
    siteApplicationid: number
    assignRole: string
    assignedId: number
}

export type DLMSiteApplicationsListContextProps = { 
    sites: Array<DLMSiteApplication>
    workflow: string
    state: QueryState
    updateState: (updates: Partial<QueryState>) => void
    currentSite : DLMSiteApplication | null
    setCurrentSite : Dispatch<SetStateAction<DLMSiteApplication | null>>
    itemIDForDelete: ID,
    setItemIDForDelete: Dispatch<SetStateAction<ID>>
    itemIDForUpdate: ID,
    setItemIDForUpdate: Dispatch<SetStateAction<ID>>
    applicationOwnerId: number
    objectOption1? : DLMLabelObject | null
    setObjectOption1? : Dispatch<SetStateAction<DLMLabelObject | null>>
    resubmitData: DLMApplication | null
    setResubmitData : Dispatch<SetStateAction<DLMApplication | null>>
}

const initialDLMSiteApplicationsListContextProps  = {
    sites: [],
    workflow: '',
    state: initialQueryState,
    updateState: () => {},
    currentSite: null, 
    setCurrentSite: () => {}, 
    itemIDForDelete: undefined,
    setItemIDForDelete: () => {},
    itemIDForUpdate: undefined,
    setItemIDForUpdate: () => {},
    applicationOwnerId: 0,
    objectOption1: null,
    setObjectOption1: () => {},    
    resubmitData: null,
    setResubmitData: () => {},
}

const DLMSiteApplicationsListContext = createContext<DLMSiteApplicationsListContextProps>(initialDLMSiteApplicationsListContextProps);

export type DLMSiteApplicationsListProps = {
    sites: Array<DLMSiteApplication>
    workflow: string
    applicationOwnerId: number
}

const DLMSiteApplicationsListContextProvider: FC<DLMSiteApplicationsListProps & WithChildren> = ({sites, workflow, applicationOwnerId, children}) => {
    const [state, setState] = useState<QueryState>(initialQueryState)
    const [currentSite, setCurrentSite] = useState<DLMSiteApplication | null>(null)

    const [itemIDForDelete, setItemIDForDelete] = useState<ID>();
    const [itemIDForUpdate, setItemIDForUpdate] = useState<ID>();
    const [objectOption1, setObjectOption1] = useState<DLMLabelObject | null>(null)

    const [resubmitData, setResubmitData] = useState<DLMApplication | null>(null)

    const updateState = (updates: Partial<QueryState>) => {
        const updatedState = {...state, ...updates} as QueryState
        setState(updatedState)
    } 

    return(
    <DLMSiteApplicationsListContext.Provider value={{
        sites, 
        workflow,
        state, 
        updateState, 
        currentSite, 
        setCurrentSite,
        itemIDForDelete, setItemIDForDelete, 
        itemIDForUpdate, setItemIDForUpdate, 
        applicationOwnerId,
        objectOption1, setObjectOption1,
        resubmitData, setResubmitData,
    }}>
        {children}
    </DLMSiteApplicationsListContext.Provider>
    )
}

const useDLMSiteApplicationsListContext = () => useContext(DLMSiteApplicationsListContext);

export { DLMSiteApplicationsListContextProvider, useDLMSiteApplicationsListContext}